<div [ngClass]="getBorderClasses()">
  <div class="flex flex-row w-full justify-between items-center">
    <p class="font-bold flex-1">
      <span [innerHTML]="text"></span>
    </p>

    <div class="flex flex-row gap-3 items-center">
      <button *ngIf="showButton" (click)="callButton()" matSuffix mat-raised-button [color]="colorButton">
        {{ textButton }}
      </button>

      <!-- Bouton de fermeture -->
      <button
        *ngIf="dismissible"
        (click)="dismiss()"
        mat-icon-button
        class="text-gray-500 hover:text-gray-700"
        matTooltip="Fermer"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>
